import React, { useState, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import VideoModal from '../VideoModal'
import { Header, PatreonFooter, Footer, MobileNewStoryButton } from 'components'
import { setChatRequest, setMeetReview } from '../../modules/messages/actions'
import { setMeetingNotifications, setChatUser, setUsersMessages, setUpdateMessage, setIsMobile, setGetChats, setUserFromId } from '../../modules/chatCategory/actions'
import { signInAction, googleId, logOut } from '../../modules/session/actions'
import { setScroll } from '../../modules/scroll/actions'
import apiChat from '../../api/chat'
import apiAuth from '../../api/auth'
import { Notification, SideBar, SignUpModal, NotificationBar, Unsubscribe, ScrollPlayer } from '../UI'
import BanModal from '../BanModal'
import axios from 'axios'
import './index.scss'
import io from 'socket.io-client'
import { useDebouncedCallback } from 'use-debounce'

const Layout = ({ children }) => {
  const [openAlert, setOpenAlert] = useState()
  const [scrollY, setScrollY] = useState()
  const [notifications, setNotifications] = useState()
  const [meetMessage, setMeetMessage] = useState()
  const [open, setOpen] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const locations = useLocation()
  const { pathname } = useLocation()
  const { user, chatStoryId, notRegisterStory } = useSelector(({ session }) => session)
  const { chatUser } = useSelector(({ chat }) => chat)
  const path = pathname.split('/')?.[1]
  const [socket, setSocket] = useState(null)
  const [openNot, setOpenNot] = useState(false)
  const [readNotifacotions, setReadNotifications] = useState()
  const [openRegister, setOpenRegister] = useState(false)
  const [sucssesDelete, setOnSucssesDElete] = useState(false)
  const [userInfo, setUserInfo] = useState({})
  const faviconCounter = document.getElementById('iconCounter')
  const [countMeet, setCountMeet] = useState(0)
  const [countNot, setCountNot] = useState(0)
  const [wasExist, setWasExist] = useState(false)
  const [subscribe, setSubscribe] = useState(false)
  const [lastMessageId, setLastMessageId] = useState('')
  const [openBanModal, setOpenBanModal] = useState(false)
  const { audioState, activeScroll } = useSelector(({ audio }) => audio)
  const [scrollTop, setScrollTop] = useState(0)
  const [activePlayer, setActivePlayer] = useState(false)
  const [activePlayerBootom, setActivePlayerBootom] = useState(false)
  const [activeFooter, setActiveFooter] = useState(false)
  const [openLogin, setOpenLogin] = useState(false)
  const [session, setSession] = useState(null)

  useEffect(() => {
    setSession(sessionStorage.getItem('session'))
  }, [sessionStorage.getItem('session'), session])

  useEffect(() => {
    if (pathname === '/') {
      setActiveFooter(true)
    } else if (pathname === '/troubled') {
      setActiveFooter(true)
    } else if (pathname === '/empowered') {
      setActiveFooter(true)
    } else {
      setActiveFooter(false)
    }
  }, [pathname])

  const scrollHandler = e => {
    setScrollTop(e.target.scrollTop)
  }

  useEffect(() => {
    if (scrollTop < activeScroll?.activeScroll?.offsetTop - activeScroll?.activeScroll?.offsetHeight) {
      setActivePlayerBootom(true)
    } else {
      setActivePlayerBootom(false)
    }
    if (scrollTop < activeScroll?.activeScroll?.offsetTop + activeScroll?.activeScroll?.offsetHeight - 230) {
      setActivePlayer(false)
    } else {
      setActivePlayer(true)
    }
    window?.addEventListener('scroll', scrollHandler, true)

    return function () {
      window.removeEventListener('scroll', scrollHandler, true)
    }
  }, [activeScroll])

  useEffect(() => {
    setActivePlayer(false)
    setActivePlayerBootom(false)
  }, [audioState?.src])

  const debouncedUpdate = useDebouncedCallback(
    data => {
      dispatch(setUpdateMessage(data))
      getMeetingsNotifications()
      getNotificationsReadr()
      dispatch(setGetChats(true))
      getNotifications()
    }, 2000,
  )

  const debouncedNewMess = useDebouncedCallback(
    data => {
      dispatch(setMeetingNotifications({ ...data?.message }))
      getMeetingsNotifications()
      dispatch(setGetChats(true))
      getNotifications()
      dispatch(setUserFromId(data?.message))
    }, 2000,
  )

  const debouncedDelete = useDebouncedCallback(
    data => {
      dispatch(setMeetingNotifications({ ...data?.message }))
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    }, 1000,
  )

  const goTo = path => history.push(path)

  const disconnectUser = () => socket.disconnect()

  const getMeetingsNotifications = () => {
    apiChat.getNotifications(user?.accessKey, '1', 'new_message', false)
      .then(res => {
        setMeetMessage(res?.data?.notifications)
        setLastMessageId('')
      })
  }

  const getNotificationsReadr = () => {
    apiChat.getNotificationsRead(user?.accessKey, '0', true)
      .then(res => setReadNotifications(res?.data?.notifications))
  }

  const getNotifications = () => {
    apiChat.getNotificationsRead(user?.accessKey, '0', false)
      .then(res => {
        setNotifications(res?.data?.notifications)
        getNotificationsReadr()
      })
  }

  useEffect(() => {
    if (pathname === '/chat/meeting-scheduled') {
      setTimeout(() => {
        getMeetingsNotifications()
      }, 1500)
    }
  }, [pathname, chatUser?.uuid])

  useEffect(() => {
    if (path === 'chat') {
      if (chatUser?.lastMessage?.uuid) {
        setLastMessageId(chatUser?.lastMessage?.uuid)
      }
    }
  }, [path, chatUser?.lastMessage?.uuid])

  useEffect(() => {
    if (lastMessageId) {
      setTimeout(() => {
        getMeetingsNotifications()
      }, 1500)
    }
  }, [lastMessageId])

  useEffect(() => {
    if (chatUser?.lastMessage?.uuid) {
      setTimeout(() => {
        getMeetingsNotifications()
      }, 1500)
    }
  }, [chatUser?.lastMessage?.uuid])

  useEffect(() => {
    if (chatStoryId) {
      if (user?.accessKey) {
        if (wasExist) {
          goTo(`/story/${chatStoryId}`)
        }
      }
    }
  }, [chatStoryId, user?.accessKey, wasExist])

  useEffect(() => {
    if (notRegisterStory?.type) {
      if (user?.accessKey) {
        if (wasExist) {
          goTo(`/story/${notRegisterStory?.storyId}`)
        }
      }
    }
  }, [notRegisterStory?.type, user?.accessKey, wasExist])

  useEffect(() => {
    if (user?.accessKey) {
      apiAuth?.checkAuth(user?.accessKey, -new Date().getTimezoneOffset() / 60)
        .then(({ data }) => {
          if (data?.error?.message === 'Access denied') {
            dispatch(logOut(null))
          }
        })
    }
  }, [user?.accessKey])

  useEffect(() => {
    if (process.env.REACT_APP_SOCKET_API_URL) {
      if (user?.accessKey) {
        setSocket(io(process.env.REACT_APP_SOCKET_API_URL, {
          query: { accessKey: user?.accessKey },
          rejectUnauthorized: false,
        }))
      }
    }
  }, [user?.accessKey, process.env.REACT_APP_SOCKET_API_URL])

  const onLogOut = () => {
    dispatch(logOut(null))
    history.push('/')
    disconnectUser()
  }

  const onSignUp = () => {
    apiAuth.loginGuoogle().then(e => {
      dispatch(googleId(e?.data?.url))
      if (e?.data?.url) {
        window.location.href = e?.data?.url
        dispatch(signInAction(e?.data))
      }
    })
  }

  const unsubscribeMail = setSucsses => {
    if (pathname === '/unsubscribe') {
      apiAuth.updateUser(user?.accessKey, {
        disableInformationEmails: true,
      }).then(() => setSucsses(true))
    } else {
      apiAuth.updateUser(user?.accessKey, {
        disableNotificationEmails: true,
      })
    }
  }

  useEffect(() => {
    if (!socket) return
    socket.on('connect', () => {
    })
    socket.on('like', data => {
      dispatch(setChatRequest({ ...data?.message }))
      getNotifications()
      dispatch(setGetChats(true))
    })
    socket.on('anonymous_like', data => {
      dispatch(setChatRequest({ ...data?.message }))
      getNotifications()
      dispatch(setGetChats(true))
    })
    socket.on('no_town', data => {
      getNotifications()
      dispatch(setGetChats(true))
    })
    socket.on('update_message', data => {
      debouncedUpdate(data)
    })
    socket.on('delete_message', data => {
      debouncedDelete(data)
    })
    socket.on('delete_chat', data => {
      dispatch(setGetChats(true))
      getNotifications()
      dispatch(setChatUser(null))
      getMeetingsNotifications()
    })
    socket.on('new_message', data => {
      debouncedNewMess(data)
    })
    socket.on('meeting_review', data => {
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    })
    socket.on('before_meeting', data => {
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    })
    socket.on('add_story_to_chat', data => {
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    })
    socket.on('story_report', data => {
      dispatch(setGetChats(true))
      getNotifications()
    })
    socket.on('close_chat', data => {
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    })
    socket.on('refuse_chat', data => {
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    })
    socket.on('delete_story_from_chat', data => {
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    })
    socket.on('meeting_refused', data => {
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    })
    socket.on('chat_status_changed', data => {
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    })
    socket.on('story_created', data => {
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    })
    socket.on('chat_review', data => {
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    })
    socket.on('account_deleted', data => {
      onLogOut()
    })
    socket.on('own_story_deleted', data => {
      dispatch(setGetChats(true))
      getNotifications()
      getMeetingsNotifications()
    })
    socket.on('disconnect', () => {
      console.error('disconnects')
    })
  }, [socket])

  useEffect(() => {
    dispatch(setMeetReview({ data: 'data' }))
    dispatch(setScroll({ scroll: scrollY > 393 }))
  }, [scrollY])

  useEffect(() => {
    if (user?.accessKey) {
      getMeetingsNotifications()
      getNotifications()
      dispatch(googleId(null))
    }
  }, [user?.accessKey])

  useEffect(() => {
    if (locations?.pathname === '/auth/google/redirect') {
      if (!user?.accessKey) {
        axios.post(`${process.env.REACT_APP_API_URL}/login/google`, {
          code: locations?.search?.split('code=')?.[1]?.split('&')?.[0],
        })
          .then(({ data }) => {
            if (data?.error?.message === 'Such email was blocked') {
              setOpenBanModal(true)
            } else {
              if (data?.wasExist) {
                if (data?.user?.isAdmin) {
                  dispatch(signInAction({ ...data }))
                  history.push('/admin/illustrations')
                } else {
                  dispatch(signInAction({ ...data }))
                  history.push('/')
                  setWasExist(true)
                }
              } else if (!data?.wasExist) {
                if (data?.user?.isAdmin) {
                  setUserInfo({ ...data })
                  history.push('/admin/illustrations')
                } else {
                  setOpenRegister(true)
                  setUserInfo({ ...data })
                }
              }
            }
          })
          .catch(res => console.error(res))
      }
    }
  }, [locations?.pathname, user?.accessKey])

  // useEffect(() => {
  //   dispatch(signInAction({
  //     accessKey: '007cad6f-ab79-4296-b18a-69a290792039',
  //     status: 'ok',
  //     uuid: '38fe20d3-1fd1-4a99-8617-3cdfe7c3ffc8',
  //     wasExist: true,
  //     user: {
  //       uuid: '7e7ed443-4fb3-40e4-a27d-65838e7e9ba4',
  //       name: 'User',
  //       email: 'i.rudiuk1997.11.22@gmail.com',
  //       isOnline: false,
  //       password: '',
  //       town: 'fff',
  //       isAdmin: false,
  //       disableInformationEmails: false,
  //     },
  //   }))
  // }, [])

  // useEffect(() => {
  //   dispatch(signInAction({
  //     accessKey: 'c72a4bac-b4bd-415b-977c-368f7b008142',
  //     status: 'ok',
  //     uuid: '38fe20d3-1fd1-4a99-8617-3cdfe7c3ffc8',
  //     wasExist: true,
  //     user: {
  //       uuid: '6fbaf685-31a3-4a21-8b4e-f517cfd4a716',
  //       name: 'Admin',
  //       email: 'i.rudiuk1997.11.22@gmail.com',
  //       isOnline: false,
  //       password: '',
  //       town: 'fff',
  //       isAdmin: true,
  //       disableInformationEmails: false,
  //     },
  //   }))
  // }, [])

  useEffect(() => {
    const handleResize = () => dispatch(setIsMobile(window.innerWidth < 1280))
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (+meetMessage?.length) {
      setCountMeet(+meetMessage?.length)
    } else {
      setCountMeet(0)
    }
    if (+notifications?.length) {
      setCountNot(+notifications?.length)
    } else {
      setCountNot(0)
    }
  }, [notifications, meetMessage])

  useEffect(() => {
    faviconCounter.innerHTML = countMeet || countNot ? `(${countMeet + countNot}) tellMe` : 'tellMe'
  }, [countMeet, countNot])

  const onCloseRegister = () => setOpenRegister(false)

  useEffect(() => {
    if (pathname === '/unsubscribeFull') {
      setSubscribe(true)
    }
    if (pathname === '/unsubscribe') {
      setSubscribe(true)
    }
  }, [pathname])

  useEffect(() => {
    if (path !== 'chat') {
      dispatch(setChatUser({}))
      dispatch(setUsersMessages([]))
    }
  }, [path])

  return (
    <>
      <VideoModal isAuth={user?.accessKey} />

      <div className='layout' onScroll={e => setScrollY(e.target.scrollTop)}>
        <BanModal open={openBanModal} setOpen={setOpenBanModal} goTo={goTo} onSignUp={onSignUp} />
        {!user?.user?.disableInformationEmails && (
          <Unsubscribe open={subscribe} onClose={setSubscribe} unsubscribeMail={unsubscribeMail} />
        )}
        {path !== 'terms' && path !== 'privacy' && (
          <SignUpModal user={userInfo} open={openRegister} onClose={onCloseRegister} setWasExist={setWasExist} />
        )}
        <NotificationBar setOpen={setOpen} setOpenSide={setOpenNot} openSide={openNot} notifications={notifications} getNotifications={getNotifications} readNotifacotions={readNotifacotions} />
        <Notification text={openAlert} open={openAlert} type='error' onClose={setOpenAlert} />
        <Notification deleteText text="Account deleted. You're welcome to try again anytime." open={sucssesDelete} onClose={setOnSucssesDElete} type='success' />

        <SideBar disconnectUser={disconnectUser} user={user} setOpenSide={setOpen} openSide={open} setOnSucssesDElete={setOnSucssesDElete} />
        <MobileNewStoryButton goTo={goTo} isSession={sessionStorage.getItem('session')} />
        {path !== 'new-story' && path !== 'admin' && (
          <Header
            meetMessage={meetMessage}
            setOpen={setOpen}
            open={open}
            notifications={notifications}
            setOpenSide={setOpenNot}
            openSide={openNot}
            openLogin={openLogin}
            setOpenLogin={setOpenLogin}
          />
        )}

        {audioState?.src && <ScrollPlayer activePlayer={activePlayer} activePlayerBootom={activePlayerBootom} />}

        {children}

        {!user?.accessKey && activeFooter && (
          !openRegister && (
            !openLogin && (
              sessionStorage.getItem('session') && <Footer goTo={goTo} />
            )
          )
        )}

        {!sessionStorage.getItem('session') && activeFooter && <PatreonFooter setSession={setSession} />}
      </div>
    </>
  )
}

export default Layout
